export default "__VITE_ASSET__ClSZxeo4__"